"use strict";

let AllowHideAllDivs = true;
let PageSizeCallback = () => { };
let PageResizeCallback = () => { };
let MenuScrollTop;
let Menu;
let MenuTop;
let PageEndMilliseconds = 0;
let AllowZoom = true;

// eslint-disable-next-line no-unused-vars
function SetupEncompassSiteMapHeader() {
    requestIdleCallback(() => {
        Menu = document.getElementById("Menu");
        MenuTop = document.getElementById("MenuTop");

        if (IsImpersonateUser) {
            if (Menu) {
                Menu.classList.add("MenuCollapsed");
            }

            if (MenuTop) {
                MenuTop.classList.add("MenuCollapsed");
            }

            const content = document.getElementById("Content");
            if (content) {
                content.classList.add("MenuCollapsed");
            }

            const application = document.querySelector("#Header .Application");
            if (application) {
                application.classList.add("MenuCollapsed");
            }
        }

        if (Menu) {
            // Task 698176: Removing a user's permission to view a certain dashboard does not remove it from their menu until after they click the 'Refresh' icon
            // Task 702904: Dashboard Menu is not showing the correct dashboards when logged in.
            const CurrentLocalStorageKey = `DashboardMenuHTML_${Math.floor(Date.now() / 86400000)}_${UserID}_${UserType}_${IsImpersonateUser}_Key`;
            let DashboardMenuHTML;
            try {
                DashboardMenuHTML = EC_Fmt.GetLocalStorageValue(CurrentLocalStorageKey);
            } catch (e) {
                DashboardMenuHTML = "Cookies Must Be Enabled";
            }

            requestIdleCallback(() => {
                if (DashboardMenuHTML !== "Cookies Must Be Enabled") {
                    for (let i = 0, len = localStorage.length; i < len; i++) {
                        const key = localStorage.key(i);
                        if (key?.startsWith("DashboardMenuHTML_") && key !== CurrentLocalStorageKey) {
                            localStorage.removeItem(key);
                        }
                    }
                }
            });

            if (!DashboardMenuHTML) {
                let GetDashboardMenuURL = "api?APICommand=GetDashboardMenu";

                if (UserType === "Guest" || Date.now() > parseInt(EC_Fmt.GetCookie("ExpireTime"))) {
                    const token = "bc1020ae20b607f7318ff7c782c6d8ef";
                    GetDashboardMenuURL += `_Guest&APIToken=${token}&EncompassID=${Distributor}&${EC_Fmt.Get_QueryString("", "DashboardID;DestURL", false, false)}`;
                } else {
                    // Task 701744: Open QuickLink left menu error happen.
                    GetDashboardMenuURL += `&${EC_Fmt.Get_QueryString("", "DashboardID;DashboardVersionID;DestURL;CustomerID;ProductID;ChainID;UserID;SupplierID;APAccountID;RouteID;QuickKey", true, true)}`;
                }

                fetch(GetDashboardMenuURL, {
                    credentials: "same-origin"
                }).then(response => response.text()).then((returnHTML) => {
                    // Task 715352: Menu showing user error Session Expired URL Does not include APIToken
                    if (returnHTML.startsWith("{")) {
                        EWS.Login(() => {
                            window.location.reload(true);
                        });
                    } else {
                        // Task 679154: Home>Menu: URL does not include APIToken and User is not logged on.
                        WriteDashboardMenuHTML(returnHTML);

                        // Task 938582: Error when loading the left side dashboard menu: cannot connect to database server
                        if (returnHTML.startsWith("<div")) {
                            // Task 951021: JavaScript Error: includes/DefaultAll.min.js (1) - uncaught exception: QuotaExceededError. use 14.22KB
                            EC_Fmt.SetLocalStorageValue(CurrentLocalStorageKey, returnHTML);
                        }
                    }
                });
            } else {
                WriteDashboardMenuHTML(DashboardMenuHTML);
            }

            let expandingTimeout;
            let collapsingTimeout;

            const Menumouseenter = () => {
                clearTimeout(collapsingTimeout);
                if (Menu.classList.contains("MenuCollapsed")) {
                    expandingTimeout = setTimeout(() => {
                        Menu.style.width = "256px";
                        Menu.querySelector(".Content").style.overflowY = "auto";
                        Menu.classList.add("open-temp");

                        const highlightedSection = Menu.querySelector(".CategoryHighlight.Relative");
                        if (highlightedSection) {
                            highlightedSection.style.background = "";
                            highlightedSection.style.boxShadow = "";

                            const expandedSubCategory = highlightedSection.querySelector("div[id$='Category']");
                            if (expandedSubCategory) {
                                expandedSubCategory.style.display = "";
                            }
                        }
                        if (MenuTop) {
                            MenuTop.style.width = "256px";
                            MenuTop.classList.remove("MenuCollapsed");
                            MenuTop.classList.add("MenuOpened");
                        }
                    }, 450);
                }
            };
            const Menumouseleave = () => {
                clearTimeout(expandingTimeout);
                if (Menu.style.width && Menu.classList.contains("MenuCollapsed")) {
                    collapsingTimeout = setTimeout(() => {
                        CollapseAndUnHighlightMenu();
                        Menu.style.width = "";
                        Menu.classList.remove("open-temp");
                        Menu.querySelector(".Content").style.overflowY = "hidden";
                        if (MenuTop) {
                            MenuTop.style.width = "";
                            MenuTop.classList.remove("MenuOpened");
                            MenuTop.classList.add("MenuCollapsed");
                        }
                    }, 450);
                }
            };
            if (MenuTop && !EC_Fmt.isMobile) {
                MenuTop.addEventListener("mouseenter", Menumouseenter, {
                    passive: true
                });
                MenuTop.addEventListener("mouseleave", Menumouseleave, {
                    passive: true
                });
                MenuTop.addEventListener("touchmove", (event) => {
                    event.stopPropagation();
                }, {
                    passive: true
                });
            }

            Menu.addEventListener("mouseenter", Menumouseenter, {
                passive: true
            });
            Menu.addEventListener("mouseleave", Menumouseleave, {
                passive: true
            });
            Menu.addEventListener("touchmove", (event) => {
                event.stopPropagation();
            }, {
                passive: true
            });

            requestIdleCallback(() => {
                Menu.scrollLeft = 0;
            });
        }

        const MainMenuItemHighlight = document.querySelector(".MainMenuItemHighlight");
        if (MainMenuItemHighlight) {
            if (EC_Fmt.isVisible(MainMenuItemHighlight)) {
                MainMenuItemHighlight.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
            } else {
                MainMenuItemHighlight.parentElement.parentElement.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
            }
            if (MainMenuItemHighlight.classList.contains("ews-unshared-menu-item") && typeof Settings === "object") {
                const MainMenuItemNoCategory = document.querySelector(".NoCategory");

                if (MainMenuItemNoCategory) {
                    const addViewRoleDiv = document.createElement("div");
                    addViewRoleDiv.classList.add("ActionButtonContainer");
                    addViewRoleDiv.setAttribute("title", "Add View Role");
                    addViewRoleDiv.innerHTML = `<a class='ActionButton ActionButtonEdit'href='Home?DashboardID=${ECP.CommonDashboards.TableView}&SubTableJoinID=DashboardsRoles_Dashboards&TableName=Dashboards&Search=DashboardID~${Settings.DashboardID}'id=ActionButtonAddViewRole><div class=Title><span class=ews-icon-edit></span>Add View Role</div></a>`;

                    MainMenuItemNoCategory.appendChild(addViewRoleDiv);
                }
            }
        }

        // Task 723415: If the DashboardID is not in the URL, add it so that sharing URLs with others and recently visited works correctly
        // Task 959560: Add EncompassID to the URL on test sites to make links to them work better
        // Task 1017499: The EC_Fmt.GetURLParameters method will not be processed '#'
        EC_Fmt.ReplaceState(window.history.state || {}, document.title, window.location.search + window.location.hash);

        // Task 723415: Add current page to the recently visited list
        if (UserType !== "Guest") {
            EWS.Ready(() => {
                requestIdleCallback(() => {
                    // Task 723415: Setup a mutation observer to catch if the title on the page is updated, need to update the title in the RecentlyVistedPages cache
                    // Task 1029399: System Error: JavaScript Error: includes/DefaultAll.min.js (1) - TypeError: window.WebKitMutationObserver is not a constructor
                    const titleObserver = new window.MutationObserver(((mutations) => {
                        mutations.forEach((mutation) => {
                            let recentlyVisited = EC_Fmt.GetLocalStorageValue(`RecentlyVisitedPages_${UserID}`);
                            if (recentlyVisited) {
                                recentlyVisited = JSON.parse(recentlyVisited);
                            } else {
                                recentlyVisited = { pages: [] };
                            }
                            const lastIndex = recentlyVisited.pages.length - 1;
                            if (recentlyVisited.pages[lastIndex].title === "Table View") {
                                recentlyVisited.pages.splice(lastIndex, 1);
                            }
                            // Remove eChat notification from the title number
                            const cleanTitle = mutation.target.textContent.replace(/\(\d+\)$/, "");
                            for (let i = 0; i < recentlyVisited.pages.length; i++) {
                                if (recentlyVisited.pages[i].title === cleanTitle) {
                                    recentlyVisited.pages.splice(i, 1);
                                }
                            }
                            recentlyVisited.pages.push({ title: cleanTitle, URL: window.location.pathname + window.location.search });
                            if (recentlyVisited.pages.length > 15) {
                                recentlyVisited.pages.shift();
                            }

                            EC_Fmt.SetLocalStorageValue(`RecentlyVisitedPages_${UserID}`, JSON.stringify(recentlyVisited));
                        });
                    }));
                    titleObserver.observe(document.querySelector("head > title"), { subtree: true, characterData: true, childList: true });

                    // Task 723415: Pushing the current page into the recently visited list
                    let recentlyVisited = EC_Fmt.GetLocalStorageValue(`RecentlyVisitedPages_${UserID}`);
                    if (recentlyVisited) {
                        recentlyVisited = JSON.parse(recentlyVisited);
                    } else {
                        recentlyVisited = { pages: [] };
                    }
                    // Remove eChat notification from the title number
                    const cleanTitle = document.title.replace(/\(\d+\)$/, "");
                    for (let i = 0; i < recentlyVisited.pages.length; i++) {
                        if (recentlyVisited.pages[i].title === cleanTitle) {
                            recentlyVisited.pages.splice(i, 1);
                        }
                    }
                    recentlyVisited.pages.push({ title: cleanTitle, URL: window.location.pathname + window.location.search });
                    if (recentlyVisited.pages.length > 15) {
                        recentlyVisited.pages.shift();
                    }
                    EC_Fmt.SetLocalStorageValue(`RecentlyVisitedPages_${UserID}`, JSON.stringify(recentlyVisited));
                }, { timeout: 300 });
            });

            // EC-20647: Add hot-key to system that allows the user to jump the focus to the universal search
            if (!EC_Fmt.isMobile) {
                document.addEventListener("keydown", (event) => {
                    if (event.key === "/") {
                        // Only continue if the user is not typing in an input or editable text region
                        let activeElement = document?.activeElement || null;
                        while (activeElement?.shadowRoot?.activeElement) {
                            activeElement = activeElement.shadowRoot.activeElement;
                        }
                        const eventTarget = typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
                        if (!IsEditableElement(activeElement) && !IsEditableElement(eventTarget)) {
                            event.preventDefault();
                            const searchInput = document.getElementById("ews-UnifiedSearch-input");
                            if (searchInput) {
                                searchInput.focus();
                                searchInput.select();
                            }
                        }
                    }
                });
            }
        }
    }, { timeout: 500 });
}

function IsEditableElement(element) {
    if (!element || !(element instanceof HTMLElement)) {
        return false;
    }

    const tagName = element.tagName;
    if (tagName === "INPUT"
        || tagName === "TEXTAREA"
        || tagName === "SELECT"
        || tagName === "ECP-INPUT"
        || tagName === "ECP-SELECT"
        || tagName === "ECP-AUTO-COMPLETE"
        || tagName === "ECP-UPLOAD") {
        return true;
    }

    if (element.isContentEditable || element.contentEditable === "plaintext-only") {
        return true;
    }

    return element.closest("input, textarea, select, ecp-input, ecp-select, ecp-auto-complete, ecp-upload, [contenteditable='true'], [contenteditable='plaintext-only']") !== null;
}

AllowZoom = true;

EWS.Ready(() => {
    const innerContent = document.querySelector("#Content .Inner");

    if (innerContent) {
        // Performance sensitive code, runs every time a user scrolls, for each pixel scrolled, please performance test if making changes
        let elementsHidden = false;

        const debouncedScrollHandler = debounce(() => {
            if (!elementsHidden) {
                hideAllElements(document.getElementsByClassName("ews-menu"));
                hideAllElements(document.getElementsByClassName("AutocompleteMenu"));
                hideAllElements(document.querySelectorAll("body > .ColumnMenu"));
                hideAllElements(document.getElementsByClassName("DateInputCalendar"));
                elementsHidden = true;
            }

            EC_Fmt.ReplaceState(
                Object.assign(window.history.state || {}, {
                    scrollTop: innerContent.scrollTop,
                    scrollLeft: innerContent.scrollLeft
                }), ""
            );
            elementsHidden = false;
        }, 1500);

        innerContent.addEventListener("scroll", debouncedScrollHandler, {
            passive: true
        });
    }

    const MainLayout = document.getElementById("MainLayout");

    if (MainLayout && MainLayout.children.length === 0 && MainLayout.innerHTML.replace(/ /g, "") === "") {
        MainLayout.innerHTML = "&nbsp;";
    }

    const debouncedResize = debounce(() => ResizeLayout(), 1500);
    window.addEventListener("resize", debouncedResize);

    window.addEventListener("click", (event) => {
        if (event.button !== 2) {
            HideAllDivs(false, event);
        }
    });

    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            // Specifically restoring from bfcache (e.g., refresh data, reset UI state)
            EWS.VerifySession();
        }
    });

    // Zoom on mobile
    if (EC_Fmt.isMobile) {
        let isScale = false;
        let dist = 0;
        let scale = 1;
        const mainLayoutTable = document.getElementById("MainLayoutTable");

        if (mainLayoutTable) {
            const zoomables = document.querySelectorAll(".Zoomable");
            const DashboardElement = document.getElementById("Dashboard");

            innerContent.style.transition = "transform 0.2s";

            innerContent.addEventListener("touchstart", (event) => {
                if (AllowZoom) {
                    const originalEvent = event;

                    if (originalEvent.touches.length === 2) {
                        isScale = true;

                        dist = Math.sqrt(
                            (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX) * (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX)
                            + (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY) * (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY)
                        );
                    }
                }
            }, {
                passive: true
            });

            innerContent.addEventListener("touchmove", (event) => {
                if (isScale && AllowZoom) {
                    const originalEvent = event;

                    if (originalEvent.touches.length < 2 || !originalEvent.touches[0] || !originalEvent.touches[1]) {
                        return false;
                    }

                    const currentDist = Math.sqrt(
                        (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX) * (originalEvent.touches[0].pageX - originalEvent.touches[1].pageX)
                        + (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY) * (originalEvent.touches[0].pageY - originalEvent.touches[1].pageY)
                    );

                    const diff = currentDist - dist;

                    if (Math.abs(diff) >= 10) {
                        const currentScale = scale + 0.0001 * (currentDist - dist);

                        if (mainLayoutTable.scrollWidth * currentScale >= window.outerWidth && currentScale <= 1.8) {
                            if (DashboardElement) {
                                DashboardElement.style.transform = `scale(${currentScale})`;
                                DashboardElement.style.transformOrigin = "0 0";
                                DashboardElement.style.width = DashboardElement.offsetWidth / scale * currentScale;
                            } else {
                                mainLayoutTable.style.transform = `scale(${currentScale})`;
                                mainLayoutTable.style.transformOrigin = "0 0";
                            }

                            for (let i = 0; i < zoomables.length; i++) {
                                const zoomable = zoomables[i];

                                zoomable.style.transform = `scale(${currentScale})`;
                                zoomable.style.transformOrigin = "0 0";
                            }

                            scale = currentScale;
                        }
                    }

                    return false;
                }
                return true;
            }, {
                passive: true
            });

            innerContent.addEventListener("touchend", () => {
                isScale = false;
                dist = 0;
            }, {
                passive: true
            });
        }

        const ApplicationVersionLinks = document.querySelectorAll(".application-versions a");
        for (let i = 0; i < ApplicationVersionLinks.length; i++) {
            ApplicationVersionLinks[i].addEventListener("click", () => {
                ECP.Dialog.Alert("Encompass Mobile download has started. Please exit your browser to view the progress.");
            });
        }
    }

    // Task 911147: Browser Render time is not accurate on dashboards
    PageEndMilliseconds = Date.now();

    const MainLayoutHeader = document.getElementById("MainLayoutHeader");
    if (MainLayoutHeader) {
        const previousEl = MainLayoutHeader.previousElementSibling;

        if (previousEl?.tagName.toLowerCase() === "tbody") {
            MainLayoutHeader.parentElement.insertBefore(MainLayoutHeader, previousEl);
        }
    }

    if (window.history.state && (window.history.state.scrollLeft !== undefined || window.history.state.scrollTop !== undefined)) {
        innerContent.scrollTo(window.history.state.scrollLeft, window.history.state.scrollTop);
    }

    ShowToolTipMessage();

    CreateSwitchDashboardVersionTypeButton(document.querySelector("#Header .Inner .switchVersionTypeContent"));

    // Task 1038521: Collapse dashboard header tabs when the user scrolls away from the header
    if (document.querySelector("#MainLayoutTable .HeaderTabsSticky")) {
        document.getElementById("MainLayoutTable").classList.add("OverflowInherit");
    }

    // Task 1113290: Move EnableLogging=true logic to save the results into a logs table
    const enableLogging = EC_Fmt.GetPageParameter("EnableLogging");
    if ((enableLogging === "true" || enableLogging === "True") && UserType !== "Guest") {
        requestIdleCallback(() => {
            ECP.Dialog.Alert("Logging recorded to the <a href='Home?DashboardID=100100&TableName=SystemLogs'>System Logs table</a>");
        }, { timeout: 2000 });
    }

    const UserMenuToggleInMenu = document.getElementById("UserMenuToggleInMenu");
    if (UserMenuToggleInMenu) {
        UserMenuToggleInMenu.addEventListener("click", async (e) => {
            let UserMenuInMenu = document.getElementById("UserMenuInMenu");
            if (!UserMenuInMenu) {
                UserMenuInMenu = await GetUserMenuInMenu();
                UserMenuInMenu.style.bottom = "68px";
                UserMenuToggleInMenu.parentElement.insertBefore(UserMenuInMenu, UserMenuToggleInMenu.nextSibling);
            }
            UserMenuInMenu.ShowMenu(UserMenuToggleInMenu);
            requestAnimationFrame(() => {
                UserMenuInMenu.style.top = "";
            });
            e.stopPropagation();
        });
    }

    const OverFlowMenu = document.getElementById("OverFlowMenu");
    if (OverFlowMenu) {
        OverFlowMenu.addEventListener("click", async (e) => {
            let HeaderOverflowMenu = document.getElementById("HeaderOverflowMenu");
            if (!HeaderOverflowMenu) {
                HeaderOverflowMenu = await GetHeaderOverflowMenu();
                OverFlowMenu.parentElement.insertBefore(HeaderOverflowMenu, OverFlowMenu.nextSibling);
                SetRenderTime();
            }
            HeaderOverflowMenu.ShowMenu(OverFlowMenu);
            e.stopPropagation();
        });
    }
});

async function GetHeaderOverflowMenu() {
    const myRequest = new ECP.EC_Request("HeaderOverflowMenu");
    myRequest.SetReturnType(ECP.EC_ReturnType.Text);
    if (EC_Fmt.GetPageParameter("DashboardID")) {
        myRequest.AddRequestVariable("DashboardID", EC_Fmt.GetPageParameter("DashboardID"));
    }
    if (EC_Fmt.GetPageParameter("TabDashboardID")) {
        myRequest.AddRequestVariable("TabDashboardID", EC_Fmt.GetPageParameter("TabDashboardID"));
    }
    const FavoriteURL = window.location.href.substring(window.location.href.indexOf("/Home?") + 1);
    myRequest.AddRequestVariable("FavoriteURL", FavoriteURL);
    let HeaderOverflowMenu = await myRequest.Submit();
    HeaderOverflowMenu = EC_Fmt.HtmlStrToElement(HeaderOverflowMenu);
    HeaderOverflowMenu.addEventListener("click", (event) => {
        const target = event.target.matches("ecp-list-item") || event.target.closest("ecp-list-item");
        if (target) {
            // EC-12307: Overlay mask not removed when tapping download Encompass Mobile
            event.target.closest("ecp-menu").CloseMenu();
        }
    });
    return HeaderOverflowMenu;
}

async function GetUserMenuInMenu() {
    const GetUserDom = document.getElementById("UserMenuToggleInMenu").querySelector(".UserStyle");
    GetUserDom.querySelector(".ews-icon-emcaretdown").classList.add("arrowup");
    let UserMenuHtml = `<ecp-menu id=UserMenuInMenu theme=neutral-light style=width:250px>`
        + `<ecp-list type=clickable>`
        + `<ecp-list-item style="margin:-16px -12px 16px -12px;background:var(--bg-object)">${GetUserDom.outerHTML}</ecp-list-item>`;
    if (!IsImpersonateUser) {
        UserMenuHtml += `<ecp-list-item onclick="EC_Fmt.OpenWithCtrlClickSupport(event,'Home?DashboardID=${ECP.CommonDashboards.MyProfile}')">`
            + `<span class='menu-status-icon ews-icon-user'></span>`
            + `<ecp-list-item-title>Profile</ecp-list-item-title>`
            + `</ecp-list-item>`;
    } else {
        UserMenuHtml += `<ecp-list-item id=cannotUseMyProfileWhileCloning>`
            + `<span class='menu-status-icon ews-icon-user'></span>`
            + `<ecp-list-item-title>Profile</ecp-list-item-title>`
            + `</ecp-list-item>`
            + `<ecp-tooltip for=cannotUseMyProfileWhileCloning placement=left>Can not use this tool while cloning another user</ecp-tooltip>`;
    }

    if (AuthenticationID > 0 && !IsImpersonateUser) {
        UserMenuHtml += `<ecp-list-item onclick="ShowSwitchDialog()">`
            + `<span class='menu-status-icon ews-icon-encompassid'></span>`
            + `<ecp-list-item-title>Switch Site</ecp-list-item-title>`
            + `</ecp-list-item>`;
    } else {
        UserMenuHtml += `<ecp-list-item id=cannotSwitchSiteWhileCloning>`
            + `<span class='menu-status-icon ews-icon-encompassid'></span>`
            + `<ecp-list-item-title>Switch Site</ecp-list-item-title>`
            + `</ecp-list-item>`
            + `<ecp-tooltip for=cannotSwitchSiteWhileCloning placement=left>Can not use this tool while cloning another user</ecp-tooltip>`;
    }

    // Remove the if-block after May 5, 2026
    if (UserType === "Support" || new Date() > new Date(Date.UTC(2026, 4, 5, 15, 30))) {
        UserMenuHtml += `<ecp-list-item action=SwitchUITheme>`
            + `<span class='menu-status-icon ews-icon-paintbrush'></span>`
            + `<ecp-list-item-title>Theme <ecp-chip color=yellow>Beta</ecp-chip></ecp-list-item-title><span class=ews-icon-emcaretdown style=transform:rotate(270deg);width:14px></span>`
            + `</ecp-list-item>`;
    }

    UserMenuHtml += `<ecp-list-item onclick="EC_Fmt.DeleteCookie('ExpireTime');window.location.href='Home?LogOnType=LogOff'">`
        + `<span class=ews-icon-logoff></span>`
        + `<ecp-list-item-title>Log out</ecp-list-item-title>`
        + `</ecp-list-item>`
        + `</ecp-list>`
        + `</ecp-menu>")`;
    UserMenuHtml = EC_Fmt.HtmlStrToElement(UserMenuHtml);
    UserMenuHtml.addEventListener("click", (event) => {
        const target = event.target.matches("ecp-list-item") || event.target.closest("ecp-list-item");
        if (target) {
            if (target.getAttribute("action") === "SwitchUITheme") {
                SwitchUITheme(target);
            } else {
                event.target.closest("ecp-menu").CloseMenu();
            }
        }
    });
    return UserMenuHtml;
}

function CreateSwitchDashboardVersionTypeButton(switchVersionTypeContent, isMobile, CurrentSettings) {
    let DashboardSetting = null;
    if (EC_Fmt.isNull(CurrentSettings) && typeof Settings === "object") {
        DashboardSetting = Settings;
    } else {
        DashboardSetting = CurrentSettings;
    }
    if (typeof DashboardSetting === "object" && DashboardSetting.ExistsBetaVersion && switchVersionTypeContent) {
        let html;

        if (isMobile) {
            html = "<div class=ews-menu-item name=SwitchVersionMenuItem>"
                + "<span class='ews-menu-icon ews-icon-dashboard'></span>"
                + "<span class='ews-menu-label inline-block'style=max-width:170px>View Beta Version</span>"
                + "<div style=position:absolute;right:0;padding-right:16px>"
                + "<div class='toggle-multiple-labels Label'>"
                + "<div class=toggle-switch-widget>"
                + "<div class=toggle-layer-small>"
                + `<input id=switchVersionTypeInput${isMobile ? "Mobile" : ""} type=checkbox class=toggle-switch-checkbox${DashboardSetting.EnableBeta ? " checked" : ""}>`
                + `<label class=switch-icon for=switchVersionTypeInput${isMobile ? "Mobile" : ""}>`
                + "</div>"
                + `${isMobile ? "" : "<span style=font-size:16px;font-weight:700;padding-left:5px;user-select:none>Beta</span>"}`
                + "</div>"
                + "</div>"
                + "</div></div>";
        } else {
            html = "<div class=\"toggle-multiple-labels Label\"id=EnableBetaBtn>";
            if (!DashboardSetting.EnableBeta) {
                html += `<ecp-btn onclick="CreateEnableBetaDialog()"type=ghost icon=ews-icon-stars>Enable Beta</ecp-btn>`;
            } else {
                html += `<ecp-btn id=OpenManageBeta type=ghost icon=ews-icon-stars>Manage beta</ecp-btn>`;
            }
            html += "</div>";
        }

        switchVersionTypeContent.innerHTML = html;

        if (!isMobile && !DashboardSetting.EnableBeta && DashboardSetting.ShowBetaDialog) {
            CreateEnableBetaDialog();
        }

        const OpenManageBeta = document.getElementById("OpenManageBeta");
        if (OpenManageBeta) {
            OpenManageBeta.addEventListener("click", async () => {
                CreateManageBetaDialog(DashboardSetting);
            });
        }
        const switchVersionTypeInput = switchVersionTypeContent.querySelector("#switchVersionTypeInput, .ews-menu-item[name='SwitchVersionMenuItem']");

        if (switchVersionTypeInput) {
            switchVersionTypeInput.addEventListener("click", async () => {
                // Task 1033298: Adding Google Analytics as a default feature of dashboards
                gtag("event", "switchDashboardVersionType", { enableBeta: DashboardSetting.EnableBeta });
                await EnableBetaVersion(DashboardSetting);
            });
        }
    } else if (switchVersionTypeContent) {
        switchVersionTypeContent.innerHTML = "";
    }
}

function clearDashboardMenuCache() {
    // Task 705574: Show More Dashboards button does not respond on iOS Safari
    try {
        localStorage.removeItem(`DashboardMenuHTML_${Math.floor(Date.now() / 86400000)}_${UserID}_${UserType}_${IsImpersonateUser}_Key`);
        // Task 916139: Redesigning the public web site with a different menu
        localStorage.removeItem(`PublicSiteMenuHTML_${Math.floor(Date.now() / 86400000)}_${UserType}`);
    } catch (e) {
        // Ignore, cookie requirement message will be shown when page refreshes (just after this)
    }
}

// eslint-disable-next-line no-unused-vars
function setPageBreadcrumbTitle(Breadcrumb, BreadcrumbURL, Title, Button) {
    let htmlB = "";
    if (!EC_Fmt.isNull(BreadcrumbURL) && !EC_Fmt.isNull(Breadcrumb)) {
        htmlB += `<a href="${BreadcrumbURL}">${Breadcrumb}</a> <span class=cut-off-line>/</span> `;
    } else if (!EC_Fmt.isNull(Breadcrumb)) {
        htmlB += `${Breadcrumb} <span class=>/</font> `;
    }
    htmlB += `<label class=font-bold>${Title}</label>`;
    if (EC_Fmt.GetPageParameter("Release")?.toLowerCase() === "false") {
        htmlB += `<ecp-chip style="margin-left:10px;height:20px" color="white">Draft</ecp-chip>`;
    }
    if (Button) {
        htmlB += `<div class=PageBreadcrumb-button>${Button}</div>`;
    }

    const PageBreadcrumb_Title = document.getElementById("PageBreadcrumb_Title");
    if (PageBreadcrumb_Title) {
        PageBreadcrumb_Title.innerHTML = htmlB;
    }
}

function WriteDashboardMenuHTML(DashboardMenuHTML) {
    // Task 636615: End of day error
    const HeaderMenuLoading = Menu.querySelector("#HeaderMenuLoading");
    if (HeaderMenuLoading) {
        const currentCategoryName = HighlightMenu(DashboardMenuHTML, HeaderMenuLoading);

        HeaderMenuLoading.id = "";
        HeaderMenuLoading.setAttribute("id", "");

        if (currentCategoryName) {
            ToggleMenuCategory(currentCategoryName, true);
        }

        if (Menu.classList.contains("MenuCollapsed")) {
            CollapseAndUnHighlightMenu();
        }

        EncompassMobileItem();
    }

    const shareButton = Menu.querySelector("#ActionButtonShare");

    if (shareButton) {
        shareButton.addEventListener("click", (event) => {
            event.preventDefault();
            Load_QuicklinkMenu(shareButton, `Home?${EC_Fmt.Get_QueryString(" ")}`, "Dashboard");
        });
    }
}

// Task 1058438: Master Task 1058050: mobile when open Side Menu, page is very narrow and still can use
function hideAllElements(elements) {
    if (elements) {
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = "none";
        }
    }
}

function CollapseAndUnHighlightMenu() {
    const highlightedSection = Menu.querySelector(".CategoryHighlight.Relative");
    if (highlightedSection) {
        const expandedSubCategory = highlightedSection.querySelector("div[id$='Category']");
        if (expandedSubCategory) {
            expandedSubCategory.style.display = "none";
        }
    }
}

function SetRenderTime() {
    const loadTime = document.getElementById("PageLoadTime");
    if (loadTime) {
        loadTime.textContent = `Server Time: ${PageLoadTime} sec`;
        const toolTip = document.createElement("ecp-tooltip");
        toolTip.setAttribute("for", "PageLoadTime");
        toolTip.textContent = "Time taken for Encompass to create and send the page";
        document.body.appendChild(toolTip);
    }

    const renderTime = document.getElementById("RenderTime");
    if (renderTime) {
        // Task 911147: Browser Render time is not accurate on dashboards
        renderTime.textContent = `Browser Render: ${Math.round(Math.abs((PageStartMilliseconds - PageEndMilliseconds) / 1000) * 100) / 100} sec`;
        const renderToolTip = document.createElement("ecp-tooltip");
        renderToolTip.setAttribute("for", "RenderTime");
        renderToolTip.textContent = "Time taken for your browser to parse and display the page";
        document.body.appendChild(renderToolTip);
    }

    setInternetSpeed();
}

function setInternetSpeed() {
    const internetSpeed = document.getElementById("InternetSpeed");
    if (internetSpeed) {
        const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

        if (isLocalhost) {
            internetSpeed.innerHTML = "Internet Speed: &#8734; {localhost}";
        } else if (navigator.connection && navigator.connection.downlink) {
            if (navigator.connection.downlink >= 10) {
                internetSpeed.textContent = "Internet Speed: 10+ Mbps";
            } else if (navigator.connection.downlink < 0.75) {
                internetSpeed.style.backgroundColor = "red";
                internetSpeed.textContent = `Internet Speed: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps (Very Slow)`;
            } else if (navigator.connection.downlink < 2) {
                internetSpeed.style.backgroundColor = "orange";
                internetSpeed.textContent = `Internet Speed: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps (Slow)`;
            } else {
                internetSpeed.textContent = `Internet Speed: ${EC_Fmt.Round(navigator.connection.downlink, 2)} Mbps`;
            }

            if (navigator.connection.rtt > 250) {
                if (EC_Fmt.isNull(internetSpeed.style.backgroundColor)) {
                    internetSpeed.style.backgroundColor = "orange";
                }
                internetSpeed.textContent += ` (High Latency)`;
            }
        } else {
            internetSpeed.textContent = "Internet Speed: unknown";
        }
    }
}

/**
 * @deprecated SubmitTo() is deprecated, it is recommended to put the action on the form directly and submit it like normal
 */
// eslint-disable-next-line no-unused-vars
function SubmitTo(Id, Url) {
    const Form = document.getElementById(Id);

    if (Form) {
        Form.setAttribute("action", Url);
        Form.submit();
    }
}

// eslint-disable-next-line no-unused-vars
function RegisterPageSizeCallback(Callback) {
    if (Callback) {
        const CurrentFunction = PageSizeCallback;

        PageSizeCallback = () => {
            CurrentFunction();
            Callback();
        };
    }
}

// eslint-disable-next-line no-unused-vars
function RegisterPageResizeCallback(Callback) {
    if (Callback) {
        const CurrentFunction = PageResizeCallback;

        PageResizeCallback = () => {
            CurrentFunction();
            Callback();
        };
    }
}

function ResizeLayout(NeedScrollToCurrent) {
    let AllowResize = true;

    if (EWS?.AllowResize) {
        AllowResize = EWS.AllowResize;
    }

    if (EC_Fmt.isMobile) {
        const userMenu = document.getElementById("ews-BC_EWS_UserMenu-menu");
        if (userMenu) {
            // Batch DOM reads to avoid layout thrashing
            const menuWidth = userMenu.offsetWidth;
            const menuHeight = userMenu.offsetHeight;

            if (!(menuWidth === 0 && menuHeight === 0)) {
                EWS.Command.HideMenu("BC_EWS_UserMenu");
                EWS.Command.ShowMenu("BC_EWS_UserMenu", document.querySelector("#Header .Inner .LabelButton[name=UserMenu]"));
            }
        }
    }

    if (AllowResize) {
        EWS.windowInnerHeight = window.innerHeight;
        EWS.windowInnerWidth = window.innerWidth;

        if (document.body && document.body.style.position !== "fixed") {
            PageResizeCallback();
            SetLayoutHeight(NeedScrollToCurrent, MenuScrollTop, Menu);
        }
    }
}

function SetLayoutHeight(NeedScrollToCurrent, NewMenuTop, LeftSideMenu) {
    if (!LeftSideMenu) {
        LeftSideMenu = Menu;
    }

    if (LeftSideMenu) {
        if (NeedScrollToCurrent) {
            // Batch DOM reads to avoid layout thrashing
            const MainMenuItemHighlight = LeftSideMenu.querySelector(".MainMenuItemHighlight");
            if (MainMenuItemHighlight) {
                // Read all layout properties first
                const highlightRect = MainMenuItemHighlight.getBoundingClientRect();
                const menuRect = LeftSideMenu.getBoundingClientRect();
                const menuOuterHeight = LeftSideMenu.outerHeight;
                const currentScrollTop = LeftSideMenu.scrollTop;

                // Calculate new scroll position
                let top = highlightRect.top - menuRect.top;

                if ((top - menuOuterHeight) > currentScrollTop) {
                    top -= menuOuterHeight / 2;

                    // Perform write operation in next frame to avoid thrashing
                    requestAnimationFrame(() => {
                        LeftSideMenu.scrollTop = top;
                    });
                }
            }
        } else {
            requestAnimationFrame(() => {
                LeftSideMenu.scrollTop = NewMenuTop;
            });
        }
    }

    if (EC_Fmt.isMobile) {
        const myDashboard = document.getElementById("Dashboard");

        if (myDashboard) {
            const MainContent = document.getElementById("Content");
            // Read classList first
            const menuOpened = Menu?.classList.contains("MenuOpened");
            const fullMenu = Menu?.classList.contains("FullMenu");
            const menuCollapsed = Menu?.classList.contains("MenuCollapsed");

            // Batch DOM writes in next frame
            requestAnimationFrame(() => {
                if (menuOpened && !fullMenu && !menuCollapsed) {
                    MainContent.style.display = `none`;
                } else {
                    // Task 1033489: No list of packaging orders displayed
                    MainContent.style.display = "flex";
                }
            });
        }

        requestAnimationFrame(() => {
            document.querySelector("meta[name=viewport]").setAttribute("content", `height=${window.outerHeight},width=device-width,minimum-scale=1.0,maximum-scale=1.0,initial-scale=1.0,user-scalable=no`);
        });
    } else {
        PageSizeCallback();
    }
}

// eslint-disable-next-line no-unused-vars
function LoadKnowledgeHelpAlerts() {
    const KnowledgeHelpAlert = document.getElementById("KnowledgeHelpAlert");

    if (KnowledgeHelpAlert) {
        const KnowledgeHelpKey = KnowledgeHelpAlert.getAttribute("KnowledgeHelpKey");
        const KnowledgeHelpKeyValue = KnowledgeHelpAlert.getAttribute("KnowledgeHelpKeyValue");

        if (EC_Fmt.isNull(KnowledgeHelpKey) || EC_Fmt.isNull(KnowledgeHelpKeyValue)) {
            return;
        }

        EWS.VerifySession(() => {
            fetch(`api?APICommand=GetKnowledgeHelpAlerts&KnowledgeHelpKey=${KnowledgeHelpKey}&KnowledgeHelpKeyValue=${KnowledgeHelpKeyValue}`, {
                credentials: "same-origin"
            }).then(response => response.json()).then((Data) => {
                if (Data.TotalCount && Data.TotalCount !== "0") {
                    KnowledgeHelpAlert.style.display = "inline-table";
                }
            });
        });
    }
}

function HideAllDivs(DestroyContent, event) {
    if (AllowHideAllDivs) {
        const hideableDivs = document.getElementsByClassName("Hideable");
        if (hideableDivs.length > 0) {
            let includesMobileTouchOverItem = false;

            if (window.MobileCurrentInput) {
                for (let i = 0; i < hideableDivs.length; i++) {
                    if (hideableDivs[i].contains(window.MobileCurrentInput)) {
                        includesMobileTouchOverItem = true;
                        break;
                    }
                }
            }

            if (!includesMobileTouchOverItem) {
                for (let i = 0; i < hideableDivs.length; i++) {
                    // EC-18980: Update autocomplete component to use new animation style
                    if (hideableDivs[i].getAttribute("inputchanged") && hideableDivs[i].classList.contains("animation-appear-from-top")) {
                        if (hideableDivs[i].getAttribute("inputchanged") === "true") {
                            hideableDivs[i].classList.add("animation-disappear-to-bottom");
                        } else if (hideableDivs[i].getAttribute("inputchanged") === "false") {
                            hideableDivs[i].classList.add("animation-disappear-to-top");
                        }
                    } else {
                        hideableDivs[i].style.display = "none";
                        hideableDivs[i].classList.remove("slide-show");
                    }

                    if (DestroyContent === true) {
                        hideableDivs[i].innerHTML = "";
                    }
                }

                if (EC_Fmt.isMobile) {
                    document.getElementById("Content").classList.remove("overflow-hidden");
                }
            }
        }
    } else {
        AllowHideAllDivs = true;
        // EC-23761: Cannot close autocomplete dropdown when it is part of ecp-menu
        if (event && event.target) {
            const el = event.target;
            if (!el.classList.contains("ColumnMenu") && el.closest(".ColumnMenu")) {
                const target = el.parentElement.querySelector(":scope > :not(:focus) .AutocompleteField");
                if (target && target.closest("section")) {
                    const filedID = target.closest("section").getAttribute("fieldid");
                    const resultList = document.getElementById(`${filedID}_Results`);
                    if (resultList) {
                        resultList.classList.add("animation-disappear-to-bottom");
                    }
                }
            }
        }
    }
}

function ToggleMainMenu() {
    if (UserType !== "Guest" && IsImpersonateUser) {
        return false;
    }

    if (!Menu.classList.contains("MenuCollapsed")) {
        if (!EC_Fmt.isMobile) {
            document.cookie = "MenuCollapsed=True;path=/";
        }
        SiteMenuToggle(true);
    } else {
        if (!EC_Fmt.isMobile) {
            document.cookie = "MenuCollapsed=False;path=/";
        }
        SiteMenuToggle(false);
    }
}

function SiteMenuToggle(visible, LeftSideMenu) {
    if (!LeftSideMenu) {
        LeftSideMenu = Menu;
    }
    const BreadCrumbMenu = document.getElementById("BreadCrumbMenuArrow");
    Menu.classList.remove("open-temp");
    LeftSideMenu.querySelector(".Content").removeAttribute("style");
    if (BreadCrumbMenu?.querySelector("span")) {
        const BreadCrumbMenuIcon = BreadCrumbMenu.querySelector("span");
        if (visible) {
            BreadCrumbMenuIcon.classList.remove("ews-icon-unlock");
            BreadCrumbMenuIcon.classList.add("ews-icon-password");
            BreadCrumbMenu.querySelector("ecp-list-item-title").textContent = "Lock sidebar open";
        } else {
            BreadCrumbMenuIcon.classList.remove("ews-icon-password");
            BreadCrumbMenuIcon.classList.add("ews-icon-unlock");
            BreadCrumbMenu.querySelector("ecp-list-item-title").textContent = "Auto-collapse sidebar";
        }
    }
    const Content = document.getElementById("Content");
    const headerApplication = document.querySelector("#Header .menu-in-header");

    LeftSideMenu.style.width = "";

    const categoryHighlight = document.getElementById("MenuInnerContents").querySelector(".CategoryHighlight");

    const mobileMenuMask = LeftSideMenu.parentElement.querySelector("#MobileMenuMask");
    if (visible) {
        if (EC_Fmt.isMobile) {
            // Task 1058438: mobile when open Side Menu, page is very narrow and still can use
            const resetPositionAfterAnimationEnd = () => {
                if (mobileMenuMask && document.getElementById("Menu").classList.contains("MenuCollapsed")) {
                    mobileMenuMask.remove();
                }
                LeftSideMenu.removeEventListener("transitionend", resetPositionAfterAnimationEnd);
            };

            LeftSideMenu.addEventListener("transitionend", resetPositionAfterAnimationEnd);
        }
        if (UserType !== "Guest" && !EC_Fmt.isMobile) {
            fetch("api?APICommand=SetMenuStatus&Collapsed=true", {
                credentials: "same-origin"
            });
        }
        LeftSideMenu.classList.add("MenuCollapsed");
        LeftSideMenu.classList.remove("MenuOpened");
        Content.classList.add("MenuCollapsed");
        Content.classList.remove("MenuOpened");

        if (headerApplication && !EC_Fmt.isMobile) {
            headerApplication.classList.add("MenuCollapsed");
            headerApplication.classList.remove("MenuOpened");
            headerApplication.style.width = "";
        }

        if (categoryHighlight) {
            const mainMenuCategory = categoryHighlight.querySelector(".MainMenuCategory");
            mainMenuCategory.nextElementSibling.style.display = "none";

            mainMenuCategory.querySelector(".ews-icon-emcaretdown").classList.remove("arrowup");
            categoryHighlight.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
        }
    } else {
        // Task 1058438: mobile when open Side Menu, page is very narrow and still can use
        if (EC_Fmt.isMobile) {
            if (!mobileMenuMask && !visible) {
                const mobileMenuMaskDIV = document.createElement("div");
                mobileMenuMaskDIV.id = "MobileMenuMask";
                mobileMenuMaskDIV.style = "position:fixed;z-index:199;top:0;left:0;width:100%;height:100%;background-color:var(--text);opacity:0.08";
                mobileMenuMaskDIV.addEventListener("click", () => { SiteMenuToggle(true); });
                LeftSideMenu.parentElement.appendChild(mobileMenuMaskDIV);
            }
        }
        if (UserType !== "Guest" && !EC_Fmt.isMobile) {
            fetch("api?APICommand=SetMenuStatus&Collapsed=false", {
                credentials: "same-origin"
            });
        }

        LeftSideMenu.classList.add("MenuOpened");
        LeftSideMenu.classList.remove("MenuCollapsed");
        Content.classList.add("MenuOpened");
        Content.classList.remove("MenuCollapsed");

        if (headerApplication && !EC_Fmt.isMobile) {
            headerApplication.classList.add("MenuOpened");
            headerApplication.classList.remove("MenuCollapsed");
        }

        if (categoryHighlight) {
            categoryHighlight.style.background = "";
            categoryHighlight.style.boxShadow = "";
            const mainMenuCategory = categoryHighlight.querySelector(".MainMenuCategory");
            if (mainMenuCategory.nextElementSibling) {
                mainMenuCategory.nextElementSibling.style.display = "block";
                mainMenuCategory.querySelector(".ews-icon-emcaretdown").classList.add("arrowup");
            }
        }
    }
}

function HighlightMenu(DashboardMenuHTML, HeaderMenuLoading) {
    const dashboardId = EC_Fmt.GetPageParameter("DashboardID");
    const tempDiv = document.createElement("div");

    tempDiv.innerHTML = DashboardMenuHTML;

    const currentPrimaryDashboard = tempDiv.querySelector(`.MainMenuPrimaryDashboards[PrimaryDashboardID='${dashboardId}']`);
    if (currentPrimaryDashboard) {
        currentPrimaryDashboard.classList.add("CategoryHighlight");
    }

    const oldCategory = tempDiv.querySelector(".CategoryHighlight");
    const oldMenuItem = tempDiv.querySelector(".MainMenuItemHighlight");
    const currentURL = window.location.href.substring(window.location.href.indexOf("aspx1") + 6);
    let currentMenuLink = tempDiv.querySelector(`.FavoritesSubcategory a[href*='${currentURL}']`);

    if (!currentMenuLink || currentMenuLink.href.substring(window.location.href.indexOf("aspx1") + 6) !== currentURL) {
        currentMenuLink = tempDiv.querySelector(`.MainMenuItem a[href*='Home?DashboardID=${dashboardId}']`);
        if (currentMenuLink?.parentElement.classList.contains("FavoritesSubcategory")) {
            currentMenuLink = null;
        }
    } else {
        // Task 738573: Edit Dashboard button is grayed out on left side menu and I am the owner.
        const dashboardMenuLink = tempDiv.querySelector(`.MainMenuItem:not(.FavoritesSubcategory) a[href*='Home?DashboardID=${dashboardId}']`);

        if (dashboardMenuLink) {
            const dashboardEditIDArr = dashboardMenuLink.parentElement.getAttribute("dashboardeditidarr");

            if (dashboardEditIDArr) {
                currentMenuLink.parentElement.setAttribute("dashboardeditidarr", dashboardEditIDArr);
            }
        }
    }

    let currentMenuItem = currentMenuLink ? currentMenuLink.parentElement : null;

    if (!currentMenuLink && !currentMenuItem) {
        currentMenuItem = tempDiv.querySelector(`.MainMenuItem[dashboardidarr*="^${dashboardId}^"]`);
    }

    let currentCategoryName = "";

    if (oldCategory) {
        const arrow = oldCategory.querySelector(".arrowup");

        if (arrow) {
            arrow.classList.remove("arrowup");
        }

        const oldCategoryHighlight = oldCategory.querySelector("div[id*='Category']");
        if (oldCategoryHighlight) {
            oldCategoryHighlight.style.display = "none";
        }

        if (oldMenuItem) {
            oldMenuItem.classList.remove("MainMenuItemHighlight");
        }
    }

    if (currentMenuItem) {
        currentMenuItem.classList.add("MainMenuItemHighlight");
        currentCategoryName = currentMenuItem.parentElement.id.replace("Category", "");
    }

    // Task 688388: CRM -> Customer Search Dashboard: Customer Dashboard is Not Taking User Back to Correct Page
    const dashboardMenuItemArr = tempDiv.querySelectorAll("[dashboardmenufilter]");
    for (let i = 0; i < dashboardMenuItemArr.length; i++) {
        const dashboardMenuItem = dashboardMenuItemArr[i];

        let FieldName = "";
        switch (dashboardMenuItem.getAttribute("dashboardmenufilter")) {
            case "Customer":
                FieldName = "CustomerID";
                break;
            case "Product":
                FieldName = "ProductID";
                break;
            case "Chain":
                FieldName = "ChainID";
                break;
            case "User":
                FieldName = "UserID";
                break;
            case "Supplier":
                FieldName = "SupplierID";
                break;
            case "APAccount":
                FieldName = "APAccountID";
                break;
            case "Route":
                FieldName = "RouteID";
                break;
        }

        if (FieldName !== "") {
            if (EC_Fmt.isInteger(EC_Fmt.GetPageParameter(FieldName))) {
                dashboardMenuItem.href += `&${FieldName}=${EC_Fmt.GetPageParameter(FieldName)}`;
            } else if (EC_Fmt.Null2EmptyStr(EC_Fmt.GetPageParameter("Parameters")).indexOf(FieldName) > -1) {
                const parameterArr = EC_Fmt.Null2EmptyStr(EC_Fmt.GetPageParameter("Parameters")).split("|");
                for (let j = 0; j < parameterArr.length; j++) {
                    const parsingParameterArr = parameterArr[j].split("~");
                    if (parsingParameterArr[0].split(":")[1] === FieldName) {
                        dashboardMenuItem.href += `&${FieldName}=${parsingParameterArr[1].split(":")[1]}`;
                        break;
                    }
                }
            }
        }
    }

    while (tempDiv.firstChild) {
        HeaderMenuLoading.appendChild(tempDiv.firstChild);
    }

    return currentCategoryName;
}

// eslint-disable-next-line no-unused-vars
function ToggleExcelMenu(Button, Name) {
    const ExcelMenu = document.getElementById(Name);

    if (ExcelMenu?.offsetWidth === 0 && ExcelMenu.offsetHeight === 0) {
        HideAllDivs();
        AllowHideAllDivs = false;

        const buttonPosition = Button.getBoundingClientRect();

        ExcelMenu.style.display = "block";
        ExcelMenu.style.top = `${buttonPosition.top + buttonPosition.height + 3}px`;
        ExcelMenu.style.left = `${buttonPosition.left}px`;
        ExcelMenu.style.zIndex = "9999";
    }
}

function SwitchUITheme(userMenuThemeOption) {
    let themeMenu = document.getElementById("ThemeMenu");
    if (!themeMenu) {
        themeMenu = document.createElement("ecp-menu");
        themeMenu.id = "ThemeMenu";
        themeMenu.setAttribute("theme", "neutral-light");
        themeMenu.style.width = "216px";
        themeMenu.classList.add("Hideable");

        themeMenu.innerHTML = `<ecp-list type=clickable><ecp-list-item selection=1><ecp-illustration illustration=ews-illustration-themelight size=m></ecp-illustration><ecp-list-item-title class="padding-left-10">${EC_Fmt.Trn("Light")}</ecp-list-item-title></ecp-list-item>`
            + `<ecp-list-item selection=2><ecp-illustration illustration=ews-illustration-themedark size=m></ecp-illustration><ecp-list-item-title class="padding-left-10">${EC_Fmt.Trn("Dark")}</ecp-list-item-title></ecp-list-item>`
            + `<ecp-list-item selection=3><ecp-illustration illustration=ews-illustration-themefollowsystem size=m></ecp-illustration><ecp-list-item-title class="padding-left-10">${EC_Fmt.Trn("System")}</ecp-list-item-title></ecp-list-item></ecp-list>`;

        const buttonPosition = userMenuThemeOption.getBoundingClientRect();
        themeMenu.style.display = "block";
        themeMenu.style.top = `${buttonPosition.top - 40}px`;
        themeMenu.style.left = `${buttonPosition.left + 216}px`;
        themeMenu.style.zIndex = "9999";

        userMenuThemeOption.closest(".Inner").appendChild(themeMenu);

        themeMenu.addEventListener("click", async (event) => {
            const target = event.target.matches("ecp-list-item") ? event.target : event.target.closest("ecp-list-item");
            const selectedTheme = target.getAttribute("selection");
            const myRequest = new ECP.EC_Request("SetAuthenticationSystemTheme");
            myRequest.AddRequestVariable("Theme", selectedTheme, ECP.EC_Verb.Get);
            const result = await myRequest.Submit();
            themeMenu.style.display = "none";
            userMenuThemeOption.closest("ecp-menu").style.display = "none";
            if (!result.status) {
                ECP.Dialog.Alert("Failed to set theme. Error has been reported to Encompass.");
            } else {
                window.location.reload();
            }
        });
    } else {
        themeMenu.classList.remove("motion-moderate");
        themeMenu.style.transform = "scale(0)";
        themeMenu.style.display = "block";
    }
    requestAnimationFrame(() => {
        themeMenu.style.transform = "scale(1)";
    });
}

// eslint-disable-next-line no-unused-vars
function ShowSwitchDialog() {
    if (AuthenticationID > 0) {
        EWS.VerifySession(async () => {
            // EC-30447: Switch Encompass system dialog redesign
            const Dialog = ECP.Dialog.ShowDialog("Switch Encompass system", "", {
                width: 384,
                barPosition: "top",
                icon: "ews-icon-arrowright",
                subTitle: "Your current session will carry over",
                disableButtons: true
            });

            const dialogContent = Dialog.querySelector(".ecp-dialog-content");
            ECP.Dialog.ShowLoading("Loading...", dialogContent, true);
            await ECP.Tools.AsyncAnimationFrame();

            const result = await fetch(`api?APICommand=CreateSiteSwitchDialog&EncompassID=${Distributor}`, {
                credentials: "same-origin"
            }).then(response => response.json());

            // Task 657698: Clone User / Switch Site vulnerability.
            if (result.Tips === undefined) {
                await ECP.Tools.AsyncAnimationFrame();

                // Apply the translated header text returned by the server
                const titleText = Dialog.querySelector(".ecp-dialog-title-text");
                if (titleText) {
                    titleText.textContent = result.title;
                }
                const subtitle = Dialog.querySelector(".ecp-dialog-subtitle");
                if (subtitle) {
                    subtitle.textContent = result.subtitle;
                }

                SiteSwitchLabels = { test: result.testSystem, expires: result.expires };

                // Task 1064395: Change the 'Switch site' modal to be an action type dialog
                dialogContent.innerHTML = result.content;
                dialogContent.classList.add("site-switch-content");
                await ECP.Tools.AsyncAnimationFrame();

                const SearchInput = Dialog.querySelector("#SiteSearchInput");

                SearchInput.addEventListener("keydown", (event) => {
                    // Task 949378: Switch Site: Change functionality of hitting enter key after typing EncompassID
                    const ItemArr = Array.from(Dialog.querySelectorAll(".site-switch-card:not(.hidden)"));
                    if (ItemArr.length === 0) {
                        return;
                    }
                    switch (event.key) {
                        case "ArrowUp":
                        {
                            event.preventDefault();
                            let index = ItemArr.indexOf(Dialog.querySelector(".site-switch-card.highlight"));
                            index = index <= 0 ? ItemArr.length - 1 : index - 1;
                            SetSiteSwitchHighlight(ItemArr, index);
                            break;
                        }
                        case "ArrowDown":
                        {
                            event.preventDefault();
                            let index = ItemArr.indexOf(Dialog.querySelector(".site-switch-card.highlight"));
                            index = index < (ItemArr.length - 1) ? index + 1 : 0;
                            SetSiteSwitchHighlight(ItemArr, index);
                            break;
                        }
                        case "Enter":
                        {
                            const highlightedItem = Dialog.querySelector(".site-switch-card.highlight");
                            EC_Fmt.TriggerEvent(highlightedItem || ItemArr[0], "click");
                            break;
                        }
                    }
                });

                SearchInput.addEventListener("keyup", (event) => {
                    switch (event.key) {
                        case "ArrowUp":
                        case "Enter":
                        case "ArrowDown":
                        {
                            break;
                        }
                        default:
                        {
                            SiteSwitchSearch(Dialog, SearchInput.value);
                            break;
                        }
                    }
                });

                // ecp-input emits "change" when its built-in clear button is used
                SearchInput.addEventListener("change", () => {
                    SiteSwitchSearch(Dialog, SearchInput.value);
                });

                SearchInput.addEventListener("paste", () => {
                    setTimeout(() => {
                        SiteSwitchSearch(Dialog, SearchInput.value);
                    }, 1);
                });

                await ECP.Tools.AsyncAnimationFrame();

                // EC-30447: InitSiteSwitchData() loads the sites asynchronously and re-centers the dialog once the list is rendered
                InitSiteSwitchData(Dialog);
                await ECP.Tools.AsyncAnimationFrame();
            }
            ECP.Dialog.HideLoading();
        });
    }
}

function SetSiteSwitchHighlight(itemArr, index) {
    for (let i = 0, len = itemArr.length; i < len; i++) {
        itemArr[i].classList.remove("highlight");
    }
    const item = itemArr[index];
    item.classList.add("highlight");
    if (item.scrollIntoViewIfNeeded) {
        item.scrollIntoViewIfNeeded();
    } else {
        item.scrollIntoView({ block: "nearest" });
    }
}

let isDialogDragAttached = false;

/**
 * @deprecated PositionDialog() is no longer supported, please use ECP.Dialog in the SDK instead
 */
// eslint-disable-next-line no-unused-vars
function PositionDialog(Dialog) {
    const Mask = document.getElementById("DialogMask");
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;
    let Width;
    let Height;

    Mask.style.width = `${clientWidth}px`;

    if (EC_Fmt.isMobile) {
        Width = clientWidth;
        Height = Dialog.outerHeight + Math.round(clientHeight - Dialog.outerHeight) / 2 - 30;

        if (Height > clientHeight) {
            Height = clientHeight;
        }

        Mask.style.opacity = "0.3";
        Dialog.style.overflow = "auto";
    } else {
        Width = Dialog?.offsetWidth;
        Height = Dialog?.offsetHeight;

        if (Width > window.outerWidth) {
            Width = window.outerWidth;
            Dialog.style.overflow = "auto";
        }

        if (Height > window.outerHeight) {
            Height = window.outerHeight;
            Dialog.style.overflow = "auto";
        }
    }

    let Top = Math.floor((window.outerHeight / 2) - (Height / 2));
    let Left = Math.floor((window.outerWidth / 2) - (Width / 2));

    Top = Math.max(Top, 0);
    Left = Math.max(Left, 0);

    Dialog.style.minWidth = `${Width}px`;
    Dialog.style.height = `${Height}px`;
    Dialog.style.marginLeft = "0";
    Dialog.style.marginTop = "0";
    Dialog.style.top = `${Top}px`;
    Dialog.style.left = `${Left}px`;
    Dialog.style.zIndex = "100000";

    const SRDOwner = document.getElementById("SRDOwner");
    if (SRDOwner) {
        SRDOwner.parentElement.style.height = SRDOwner.outerHeight + 2 * EC_Fmt.Null2ZeroInt(SRDOwner.style.borderTopWidth).replace("px", "") + 2 * EC_Fmt.Null2ZeroInt(SRDOwner.style.paddingTop).replace("px", "") + 1;
    }

    const DialogScrollContent = Dialog.querySelector(".ScrollContent");

    if (DialogScrollContent) {
        const DialogScrollContentTable = DialogScrollContent.querySelector("table");
        if (DialogScrollContentTable) {
            DialogScrollContentTable.style.border = "none";
            const DialogScrollContentCells = DialogScrollContentTable.querySelectorAll("td");
            for (let i = 0; i < DialogScrollContentCells.length; i++) {
                DialogScrollContentCells[i].style.border = "none";
                DialogScrollContentCells[i].style.borderBottom = "1px solid var(--neutral-40)";
            }
        }
    }

    const dragDialog = (handle) => {
        if (isDialogDragAttached) {
            return;
        }

        let currentDialog;
        let startX;
        let startY;
        let priorUserSelect = "";

        handle.addEventListener("mousedown", (event) => {
            currentDialog = Dialog;
            startX = event.clientX;
            startY = event.clientY;

            // Safari exposes only webkitUserSelect, so read whichever spelling holds a value; an undefined restore would leave "none" behind
            priorUserSelect = document.body.style.userSelect || document.body.style.webkitUserSelect || "";
            document.body.style.userSelect = "none";
            document.body.style.webkitUserSelect = "none";
        });

        const MoveDone = () => {
            if (currentDialog) {
                currentDialog = null;
                startX = 0;
                startY = 0;
                document.body.style.userSelect = priorUserSelect;
                document.body.style.webkitUserSelect = priorUserSelect;
            }
        };
        const MoveDialog = (e) => {
            if (currentDialog) {
                let top = (currentDialog.style.top ? parseInt(currentDialog.style.top.replace("px", "")) : 0) + e.clientY - startY;
                let left = (currentDialog.style.left ? parseInt(currentDialog.style.left.replace("px", "")) : 0) + e.clientX - startX;
                const topMaxLimit = window.innerHeight - currentDialog.clientHeight - 3;
                const leftMaxLimit = window.innerWidth - currentDialog.clientWidth;

                if (top < 0) {
                    top = 0;
                }
                if (top > topMaxLimit) {
                    top = topMaxLimit;
                }
                if (left < 0) {
                    left = 0;
                }
                if (left > leftMaxLimit) {
                    left = leftMaxLimit;
                }

                currentDialog.style.top = `${top}px`;
                currentDialog.style.left = `${left}px`;

                startY = e.clientY;
                startX = e.clientX;
            }
        };

        document.addEventListener("mousemove", MoveDialog);
        document.addEventListener("mouseup", MoveDone);

        isDialogDragAttached = true;
    };

    const DialogContent = document.querySelector(".DialogContent");

    if (DialogContent?.offsetWidth > 0 && DialogContent.offsetHeight > 0) {
        const DialogHeader = document.querySelector(".DialogHeader");
        const DialogFooter = document.querySelector(".DialogFooter");

        // Batch all DOM reads first to avoid layout thrashing
        const contentWidth = DialogContent.offsetWidth;
        const contentOuterHeight = DialogContent.outerHeight;
        const headerHeight = DialogHeader.offsetHeight;
        const footerHeight = DialogFooter.offsetHeight;

        // Then perform all DOM writes in requestAnimationFrame
        requestAnimationFrame(() => {
            if (EC_Fmt.isMobile) {
                DialogContent.style.overflow = "auto";
            }

            DialogFooter.style.width = contentWidth;

            dragDialog(DialogHeader);

            Dialog.style.height = contentOuterHeight + headerHeight + footerHeight;

            if (Dialog.outerHeight > clientHeight) {
                DialogContent.style.height = `${Height - headerHeight - footerHeight}px`;
            } else {
                DialogContent.style.height = "auto";
            }

            setTimeout(() => {
                // Re-read for second adjustment
                const newContentOuterHeight = DialogContent.outerHeight;
                const newDialogOuterHeight = Dialog.outerHeight;

                requestAnimationFrame(() => {
                    Dialog.style.height = newContentOuterHeight + headerHeight + footerHeight;

                    if (newDialogOuterHeight > clientHeight) {
                        DialogContent.height(Height - headerHeight - footerHeight);
                    } else {
                        DialogContent.style.height = "auto";
                    }
                });
            }, 1000);
        });
    } else {
        Dialog.classList.add("BoxShowNone");

        const handle = Dialog.querySelector(".DialogLayout>thead");

        dragDialog(handle);
    }
}

/**
 * @deprecated HideDialog() is no longer supported, please use ECP.Dialog in the SDK instead
 */
function HideDialog(Name) {
    if (Name === "UrlDialog") {
        document.getElementById("UrlFrame").setAttribute("src", "about:blank");
    }

    const DialogMask = document.getElementById("DialogMask");
    if (DialogMask) {
        DialogMask.style.display = "none";
    }
    const myElement = document.getElementById(Name);
    if (myElement) {
        myElement.style.display = "none";
    }
    const embedElements = document.getElementsByTagName("EMBED");
    for (let i = 0; i < embedElements.length; i++) {
        embedElements[i].style.display = "block";
    }
    const pdfIframe = document.getElementById("pdfIframe");
    if (pdfIframe) {
        pdfIframe.style.display = "block";
    }

    document.body.style.overflowX = "auto";
    document.body.style.overflowY = "auto";
    document.body.style.position = "static";
    document.body.style.minWidth = "auto";

    const ScrollPosition = document.scrollPosition;

    if (ScrollPosition) {
        window.scrollTo(ScrollPosition[0], ScrollPosition[1]);
    }
}

function ToggleMenuCategory(Category, CollapseOtherCategories) {
    const CategoryLayer = document.getElementById(`${Category}Category`);
    let Collapsed = false;

    // Task 645555: Creating Bills has Java Script error
    if (CategoryLayer !== null) {
        if (CategoryLayer.offsetWidth === 0 && CategoryLayer.offsetHeight === 0) {
            CategoryLayer.parentElement.classList.add("CategoryHighlight");
        } else {
            Collapsed = true;
            CategoryLayer.parentElement.classList.remove("CategoryHighlight");
        }

        if (CollapseOtherCategories) {
            const OtherCategories = CategoryLayer.parentElement.parentElement.querySelectorAll("div div[id$='Category']");
            for (let i = 0; i < OtherCategories.length; i++) {
                const category = OtherCategories[i];
                if (category.id && CategoryLayer.id !== category.id) {
                    if (category.offsetWidth === 0 && category.offsetHeight === 0) {
                        category.parentElement.classList.remove("CategoryHighlight");
                    } else {
                        ToggleMenuCategory(category.id.replace("Category", ""), false);
                    }
                }
            }
        }

        const CategoryArrow = document.getElementById(`${Category}Arrow`);

        if (Collapsed) {
            CategoryLayer.style.display = "none";
            CategoryArrow.classList.remove("arrowup");
        } else {
            CategoryLayer.style.display = "block";
            CategoryArrow.classList.add("arrowup");
        }

        if (CategoryLayer.id === "EncompassMobileCategory" && !Collapsed) {
            EncompassMobileItem();
        }
    }
}

// eslint-disable-next-line no-unused-vars
function OpenApplicationDownload() {
    if (document.getElementById("EncompassMobileArrow")) {
        if (Menu.classList.contains("MenuCollapsed")) {
            ToggleMainMenu();
        }
        const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
        if (EncompassMobileCategory && getComputedStyle(EncompassMobileCategory).display === "none") {
            // Task 425424
            Menu.scrollTop = 0;

            ToggleMenuCategory("EncompassMobile", true);
        }
    }
}

/**
 * @deprecated No longer supported, please use EC_Fmt.get_searchOp() directly instead
 */
function get_searchOp(Value) {
    return EC_Fmt.get_searchOp(Value);
}

/**
 * @deprecated No longer supported, please use EC_Fmt.ReplaceAll() directly instead
 */
function Replace(Value, Find, ReplaceVal) {
    return EC_Fmt.ReplaceAll(Value, Find, ReplaceVal);
}

// eslint-disable-next-line no-unused-vars
function ClockIn() {
    let TimeClockActivityID = document.getElementById("TimeClockActivityIDHidden");
    if (TimeClockActivityID) {
        TimeClockActivityID = TimeClockActivityID.value;
    }
    if (EC_Fmt.isInteger(TimeClockActivityID)) {
        fetch(`Home?LogOnType=ClockIn&TimeClockActivityID=${TimeClockActivityID}`, {
            credentials: "same-origin"
        }).then(response => response.text()).then((Data) => {
            if (Data === "Success") {
                window.location.reload();
            } else if (Data === "Already Clocked In") {
                ECP.Dialog.Alert("You are Already Clocked In");
                window.location.reload();
            } else {
                ECP.Dialog.Alert("Unable to Clock In");
            }
        });
    } else {
        ECP.Dialog.Alert("You Must Select an Activity");
    }
}

let SitesData = {};
let SiteSwitchLabels = {};

function InitSiteSwitchData(dialog) {
    SitesData = {};

    EWS.VerifySession(async () => {
        const myRequest = new ECP.EC_Request("GetSiteDatabase");
        myRequest.AddRequestVariable("EncompassID", Distributor);
        SitesData = await myRequest.Submit();

        let SitesHTML = "";
        for (let i = 0; i < SitesData.Sites.length; i++) {
            const site = SitesData.Sites[i];
            // EncompassSystems.Type 2 = Test system
            const isTest = site.Type === 2;
            const subtitle = isTest
                ? `<span>${SiteSwitchLabels.test}</span><span class=site-switch-dot></span><span>${SiteSwitchLabels.expires} ${site.Expiration}</span>`
                : `<span>${site.Domain || site.URL}</span>`;
            SitesHTML += `<div class=site-switch-card data-site="${site.Name}"tabindex=0 onclick="SwitchSiteButton(event, ${i})">`
                + `<div class=site-switch-card-main>${
                    isTest ? `<span class="ews-icon-setting site-switch-card-gear"></span>` : ""
                }<div class=site-switch-card-text>`
                + `<h4 class=site-switch-card-name title="${site.Name}">${site.Name}</h4>`
                + `<div class=site-switch-card-sub>${subtitle}</div>`
                + `</div>`
                + `</div>`
                + `<span class="ews-icon-arrowright site-switch-card-arrow"></span>`
                + `</div>`;
        }

        dialog.querySelector(".site-switch-list").innerHTML = SitesHTML;
        // Task 443511: show the empty state when there are no sites available to switch to
        if (SitesData.Sites.length === 0) {
            dialog.querySelector(".site-switch-list").style.display = "none";
            dialog.querySelector(".site-switch-empty").style.display = "";
        }

        // EC-30447: The dialog was centered while it was still the height of the loading state, re-center it now the site list is rendered
        await ECP.Tools.AsyncAnimationFrame();
        ECP.Dialog.CenterDialog(dialog);

        // Task 917191: System Error: JavaScript Error: includes/DefaultNoEchatAll.min.js (1) - Uncaught TypeError: Cannot read property 'length' of undefined
        const SiteSearchInput = document.getElementById("SiteSearchInput");
        SiteSearchInput.removeAttribute("disabled");
        if (SiteSearchInput) {
            SiteSearchInput.focus();
        }
    });
}

function SiteSwitchSearch(dialog, search) {
    // Task 752570: User with AllDatabases permission did not get an AuthenticationsSites record created for the Founders database
    const myItemArr = dialog.querySelectorAll(`.site-switch-card`);
    const searchLower = (search || "").toLowerCase();
    let visibleCount = 0;
    for (let i = 0; i < SitesData.Sites.length; i++) {
        const match = SitesData.Sites[i].Name.toLowerCase().indexOf(searchLower) > -1;
        myItemArr[i].classList.toggle("hidden", !match);
        myItemArr[i].classList.remove("highlight");
        if (match) {
            visibleCount++;
        }
    }

    // Show the empty state when the search matches nothing
    const emptyState = dialog.querySelector(".site-switch-empty");
    const list = dialog.querySelector(".site-switch-list");
    if (visibleCount === 0) {
        list.style.display = "none";
        emptyState.style.display = "";
    } else {
        list.style.display = "";
        emptyState.style.display = "none";
    }
}

// eslint-disable-next-line no-unused-vars
function SwitchSiteButton(event, site) {
    let SiteSwitchForm = document.getElementById("SiteSwitchForm");
    if (!SiteSwitchForm) {
        SiteSwitchForm = document.createElement("form");
        SiteSwitchForm.id = "SiteSwitchForm";
        SiteSwitchForm.name = "SiteSwitchForm";
        SiteSwitchForm.action = "Home?LogOnType=SwitchSite";
        SiteSwitchForm.method = "post";
        const InputArr = document.createElement("div");
        InputArr.innerHTML = "<input type=hidden id=SiteSwitchHidden name=SiteSwitch><input type=hidden id=SiteSwitchHiddenName name=SiteSwitchName><input type=hidden id=DomainHiddenName name=DomainName>";
        SiteSwitchForm.appendChild(InputArr);
        document.body.appendChild(SiteSwitchForm);
    }
    // AuthenticationSiteID
    document.getElementById("SiteSwitchHidden").value = SitesData.Sites[site].ID;
    // EncompassID
    document.getElementById("SiteSwitchHiddenName").value = SitesData.Sites[site].Name;
    // Domain
    document.getElementById("DomainHiddenName").value = SitesData.Sites[site].URL;
    if ((event.ctrlKey || event.metaKey) && SiteSwitchForm) {
        SiteSwitchForm.setAttribute("target", "_blank");
    }
    SiteSwitchForm.submit();
    if (SiteSwitchForm) {
        SiteSwitchForm.setAttribute("target", "_self");
    }
}

// eslint-disable-next-line no-unused-vars
async function ViewNewDashboards(ShowUnshared) {
    ECP.Dialog.ShowLoading();
    const mySetShowUnsharedDashboardRequest = new ECP.EC_Request("Dashboard_SetShowUnsharedDashboard");
    mySetShowUnsharedDashboardRequest.AddRequestVariable("ShowUnshared", ShowUnshared);
    await mySetShowUnsharedDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

// eslint-disable-next-line no-unused-vars
async function ShowHiddenDashboards(ShowDashboards) {
    ECP.Dialog.ShowLoading();
    const mySetShowDefaultDashboardRequest = new ECP.EC_Request("Dashboard_SetShowDefaultDashboard");
    mySetShowDefaultDashboardRequest.AddRequestVariable("ShowHidden", ShowDashboards);
    await mySetShowDefaultDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

// eslint-disable-next-line no-unused-vars
async function ShowOtherSiteDashboard(ShowOther) {
    ECP.Dialog.ShowLoading();
    const mySetShowOtherSiteDashboardRequest = new ECP.EC_Request("Dashboard_SetShowOtherSiteDashboard");
    mySetShowOtherSiteDashboardRequest.AddRequestVariable("ShowOther", ShowOther);
    await mySetShowOtherSiteDashboardRequest.Submit();

    clearDashboardMenuCache();
    window.location.reload();
}

// eslint-disable-next-line no-unused-vars
function ShowHideFilters() {
    const content = document.getElementById("FilterContent");
    const TableFilter = document.getElementById("TableFilter");

    if (content && TableFilter) {
        if (!(content.offsetWidth === 0 && content.offsetHeight === 0)) {
            TableFilter.classList.add("ews-icon-plus-square-o");
            TableFilter.classList.remove("ews-icon-minus-square-o");
        } else {
            TableFilter.classList.add("ews-icon-minus-square-o");
            TableFilter.classList.remove("ews-icon-plus-square-o");
        }

        content.style.display = (content.style.display === "none") ? "block" : "none";
    }
}

// Task 941168: Quickbooks Online sync shows blank page while running
async function WriteEncompassMobileItemHtml(clientApplication, clientOS, clientOSVersion) {
    const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
    EncompassMobileCategory.innerHTML = "<div class=align-center>loading...</div>";

    const myRequest = new ECP.EC_Request("GetEncompassMobileList");
    myRequest.AddRequestVariable("ClientApplication", clientApplication);
    myRequest.AddRequestVariable("ClientOS", clientOS);
    myRequest.AddRequestVariable("ClientOSVersion", clientOSVersion);

    const data = await myRequest.Submit();
    let contentHtml = "";

    for (let i = 0; i < data.length; i++) {
        const item = data[i];
        contentHtml += `<h2 style=border-bottom:0;margin-bottom:0;padding-bottom:12px>${item.ClientApplication}</h2>`;
        contentHtml += `<div class=MainMenuItem><a href="${item.DownloadURL}">Install ${item.ClientApplication} ${item.ClientVersion}</a></div>`;
    }

    EncompassMobileCategory.innerHTML = contentHtml;
}

function EncompassMobileItem() {
    const EncompassMobileCategory = document.getElementById("EncompassMobileCategory");
    const isEmptyContent = EncompassMobileCategory?.innerHTML.trim() === "";
    const isMobileDevice = navigator.maxTouchPoints > 0;

    if (EC_Fmt.isAndroid || EC_Fmt.isIOS) {
        if (isEmptyContent) {
            EncompassMobileCategory.innerHTML = "<div class=align-center>loading...</div>";

            // Task 960025: Log in window appears in front of report after using a quick link that has required login = false
            if (!IsImpersonateUser) {
                EWS.VerifySession(() => {
                    fetch("api?APICommand=GetApplicationsCategoryHtml", {
                        credentials: "same-origin"
                    }).then(response => response.text()).then((result) => {
                        EncompassMobileCategory.innerHTML = result;
                    });
                });
            }
        }
    } else if (navigator.userAgent.toLowerCase().indexOf("mac") > 0 && isMobileDevice) {
        if (isEmptyContent) {
            WriteEncompassMobileItemHtml(6, 2, 13);
        }
    } else if (navigator.userAgent.toLowerCase().indexOf("chrome") > 0 && isMobileDevice && !/Windows NT \d+\.\d+; Win\d+; x\d+/.test(navigator.userAgent)) {
        if (isEmptyContent) {
            WriteEncompassMobileItemHtml(7, 3, 7);
        }
    } else if (document.querySelector("#Menu .encompass-mobile")) {
        document.querySelector("#Menu .encompass-mobile").remove();
    }
}

// eslint-disable-next-line no-unused-vars
function ShareButtonHandle(shareButton, event) {
    if (shareButton) {
        event.stopPropagation();
        Load_QuicklinkMenu(shareButton, `Home?${EC_Fmt.Get_QueryString(" ")}`, "Dashboard");
    }
}

// eslint-disable-next-line no-unused-vars
function displayCommandMenu(name, ele, event) {
    event.stopPropagation();
    EWS.Command.ShowMenu(name, ele);
}

// eslint-disable-next-line no-unused-vars
function ShowReMindMeDialog() {
    EWS.VerifySession(() => {
        const dateTimeNow = EC_Fmt.DateTimeParseFormat(EC_Fmt.ScreenFmt(new Date(), ECP.DataType._DateTime));
        const content = `<div style="min-height:24px;position:relative;font-size:10pt;color:var(--text);cursor:pointer;padding:8px 15px 0 15px">`
            + `<div class=ews-menu-label><b>Remind Me</b>`
            + `<div class=tip-container style=margin-left:5px id=RemindMeToolTip>`
            + `<span class=ews-icon-info></span>`
            + `</div>`
            + `<ecp-tooltip for=RemindMeToolTip placement=bottom>`
            + ` Set a date and time in the dialog below`
            + ` <br>and the Remind Me feature`
            + ` <br>will send you an eChat at that time`
            + ` <br>with a link that takes you`
            + ` <br>back to the page you are on right now.`
            + `</ecp-tooltip>`
            + `</div>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:var(--text-secondary);cursor:pointer;padding:0 15px">`
            + ` <input type=Text name=remind title="Remind Me"placeholder="Reminder Message Text"style="width:300px;border:1px var(--neutral-40) solid"id=remind>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:var(--text);cursor:pointer;padding:8px 15px 0 15px">`
            + ` <div class=ews-menu-label><b>Reminder Date/Time</b></div>`
            + `</div>`
            + `<div style="min-height:24px;position:relative;font-size:10pt;color:var(--text-secondary);cursor:pointer;padding:0 15px">${ECP.HTML.DateTimeInput("myDateTime", "DateTimeField", true, dateTimeNow, "Current Date Time", 1, 290, true, dateTimeNow)}</div>`;
        const dialog = ECP.Dialog.ShowDialog("Remind Me", content, {
            width: 350,
            height: 280,
            confirmButtonTitle: "Set Reminder",
            async confirmButtonAction() {
                ECP.Dialog.ShowLoading();

                const date = dialog.querySelector("#DateTimeField").value;
                const title = dialog.querySelector("#remind").value;
                if (!date || !title) {
                    ECP.Dialog.HideLoading();
                    ECP.Dialog.Alert("Please input information.");
                    return;
                }

                const delayRequest = new ECP.EC_Request("SendRemindMeEChatMessage");

                delayRequest.AddRequestVariable("DelayedSendTime", EC_Fmt.DateTimeParseFormat(date), ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Title", title, ECP.EC_Verb.Post);
                delayRequest.AddRequestVariable("Url", window.location.href, ECP.EC_Verb.Post);
                const message = await delayRequest.Submit();
                if (message.State === "Success") {
                    // Task 1024699: Remind Me: Use Snackbar notification instead of pop-up after scheduling a reminder
                    ECP.HTML.Snackbar("Remind Me Event has been created.", "Success");
                } else {
                    ECP.Dialog.Alert(message.errors[0].detail);
                }
                ECP.Dialog.HideLoading();
            }
        });
    });
}

// eslint-disable-next-line no-unused-vars
function ShowBetaFeedbackDialog() {
    if (AuthenticationID > 0) {
        EWS.VerifySession(() => {
            // Task 1064388: UI Adjustments for the submit feedback modal
            const UserName = document.querySelector("div [name='UserMenu']").innerText.split("@")[0];
            const content = `<ecp-sectionmessage type=information>`
                + `This feedback should pertain to the beta version of this dashboard. For all other questions/comments, please`
                + ` <a href="Home?DashboardID=168976&TableEdit=Tasks">create a task</a>.`
                + `</ecp-sectionmessage>`
                + `<div style="display:padding:20px 0">`
                + `<div style="display:flex;align-items:center;padding:24px 0 0 10px">`
                + ` <span style=padding-right:30px;color:var(--neutral-50)>Dashboard</span>`
                + ` <span style=color:var(--neutral-80)>${document.head.querySelector("title").innerText}</span>`
                + `</div>`
                + `<div style="display:flex;align-items:center;padding:24px 0 0 10px">`
                + ` <span style=padding-right:30px;color:var(--neutral-50)>Your name</span>`
                + ` <span style=color:var(--neutral-80)> ${UserName} </span>`
                + `</div>`
                + `<div style="display:block;align-items:center;padding:24px 10px 0 10px">`
                + ` <textarea id=FeedbackDetail placeholder="Feedback..."name=FeedbackDetail encreq=true style=width:100%;height:160px;color:var(--text-secondary);padding:5px></textarea>`
                + `</div>`
                + `</div>`;

            const Dialog = ECP.Dialog.ShowDialog("Submit beta dashboard feedback", content, {
                width: 560,
                barPosition: "top",
                cancelButtonTitle: "Cancel",
                confirmButtonTitle: "Submit Feedback",
                async confirmButtonAction() {
                    ECP.Dialog.ShowLoading();
                    // Get Dashboard and UserData
                    const myDashboardData = new ECP.EC_TableView("Dashboards");
                    myDashboardData.AddSubTableJoinID("Dashboards_Applications");
                    myDashboardData.AddSubTableColumn("Dashboards_Applications", "Application");
                    myDashboardData.AddFilter("DashboardID", EC_Fmt.GetPageParameter("DashboardID"), ECP.EC_Operator.Equals);
                    const results = await myDashboardData.GetResults();
                    const myRecordSet = new ECP.EC_Recordset(results).Records[0];

                    // Create Task
                    let FeedbackDetail = Dialog.querySelector("#FeedbackDetail").value;
                    FeedbackDetail += `<br><br><b>User:${UserName}<br>EncompassID:${Distributor}`;
                    FeedbackDetail = `Beta Dashboard Feedback:<br>${FeedbackDetail}`;

                    const myRequest = new ECP.EC_Request("BI_CreateTask");

                    myRequest.AddRequestVariable("Detail", FeedbackDetail, ECP.EC_Verb.Get);
                    myRequest.AddRequestVariable("Task", `Beta Dashboard feedback submitted for the ${myRecordSet.Dashboard} dashboard in the ${EC_Fmt.RemoveHTMLFromStr(myRecordSet.ApplicationID)} application`, ECP.EC_Verb.Get);
                    myRequest.AddRequestVariable("AuthenticationID", myRecordSet.OwnerAuthenticationID_DBValue, ECP.EC_Verb.Get);
                    myRequest.SetReturnType(ECP.EC_ReturnType.Json);

                    const data = await myRequest.Submit();
                    const TaskID = data.TaskID;

                    ECP.Dialog.HideLoading();
                    if (TaskID) {
                        ECP.Dialog.Alert("A Task has been created");
                    } else {
                        ECP.Dialog.Alert("Task failed to be sent to support, please contact support your feedback or log a task at EncompassTech.com");
                    }
                }
            });
        });
    }
}

function ShowToolTipMessage() {
    const tipContainers = document.querySelectorAll(".tip-container");
    for (let i = 0; i < tipContainers.length; i++) {
        tipContainers[i].addEventListener("mouseenter", () => {
            const tipMessage = tipContainers[i].querySelector(".tip-description");
            tipMessage.style.display = "block";
            // Task 764637: Replace the Top Tips icon and make the pop-up dialog fixed pop-up display position in UI-Kit
            if (window.innerWidth - tipContainers[i].getBoundingClientRect().left > 222) {
                tipMessage.style.left = 0;
            } else {
                tipMessage.style.right = 0;
            }
        });

        tipContainers[i].addEventListener("mouseleave", () => {
            const tipMessage = tipContainers[i].querySelector(".tip-description");
            tipMessage.style.display = "none";
        });
    }
}

// Task 1060296: Standardizing javascript Dialogs: Need to delete the code for the old SiteMapHeader.js: ShowDialog()
// eslint-disable-next-line no-unused-vars
function EditLanguageString() {
    let url = `Home?DashboardID=100101&Action=EditColumn&TableEdit=LanguageStrings&Column=TranslationString&SelectMaxRecords=5000&TableName=LanguageStrings&SelectDisplayInParent=LanguageString,Language,OnMobile,TranslationString,TimeUpdated,UpdatedBy,TimeCreated,CreatedBy&Search=Language~${EC_Fmt.userLanguage}|LanguageString~`;
    url += encodeURIComponent(Object.keys(EC_Fmt.LocaleStrings).map(key => `${key}`).join("^"));
    url += `&`;
    window.open(url);
}

function CreateEnableBetaDialog(ShowBeta) {
    const EnableBeta = document.getElementById("EnableBeta");
    const currentTab = document.querySelector(".TableViewTabContainer .TableViewPageTab.Active");
    let DashboardName = document.head.querySelector("title").innerText;
    let DashboardSetting = null;
    if (currentTab?.getAttribute("dashboardid") && currentTab?.getAttribute("dashboardid") !== ECP.CommonDashboards.TableView.toString()) {
        DashboardSetting = {
            DashboardID: EC_Fmt.Null2ZeroInt(currentTab.getAttribute("dashboardid")),
            ExistsBetaVersion: currentTab.getAttribute("existsbetaversion") === "true",
            EnableBeta: currentTab.getAttribute("enablebeta") === "true",
            ShowBetaDialog: currentTab.getAttribute("showbetadialog") === "true",
            BetaType: EC_Fmt.Null2ZeroInt(currentTab.getAttribute("betatype"))
        };
        DashboardName = currentTab.innerText;
    } else {
        DashboardSetting = Settings;
    }
    if (EnableBeta) {
        setTimeout(() => {
            EnableBeta.style.height = "0";
            EnableBeta.style.padding = "0";
            setTimeout(() => {
                EnableBeta.remove();
            }, 400);
        }, 150);
        if (ShowBeta) {
            const myRequest = new ECP.EC_Request("Dashboard_SwitchDashboardVersionType");
            myRequest.AddRequestVariable("DashboardID", DashboardSetting.DashboardID);
            myRequest.AddRequestVariable("ShowBetaDialog", !ShowBeta);
            myRequest.Submit();
        }
    } else {
        const BetaDescriptions = [
            { TypeID: 1, Description: "Updates to the layout and visuals of each page provide a smooth, intuitive user experience.", imgUrl: "https://cdn.e8.co/GlobalDocs/615e5cc60a7aa01c5bbf55e9df19aab0.svg" },
            { TypeID: 2, Description: "Similar pages, workflows, and views are now grouped together so you can easily find what you need when you need it.", imgUrl: "https://cdn.e8.co/GlobalDocs/c77343d1d87be1611180071352903c37.svg" },
            { TypeID: 3, Description: "Refreshed branding and usability enable seamless flow from page to page.", imgUrl: "https://cdn.e8.co/GlobalDocs/11d677d702f87c9653b901b6161d69a1.svg" },
            { TypeID: 4, Description: "Exciting new features provide enhanced capabilities.", imgUrl: "https://cdn.e8.co/GlobalDocs/81c12a7a0a602de8eca65ff4ab30ffb5.svg" },
            { TypeID: 5, Description: "Important and exclusive data is now more accessible than ever.", imgUrl: "https://cdn.e8.co/GlobalDocs/2e27e6ab04d91a9d722a30546379b86e.svg" }
        ];

        const BetaDescription = BetaDescriptions.find(x => x.TypeID === DashboardSetting.BetaType);

        const html = `<div id=EnableBeta class="motion-slow attentionDialog" style=height:0;padding:0>`
            + `<div><img src=${BetaDescription.imgUrl}></div>`
            + `<div>`
            + `<div>Try the beta ${DashboardName}</div>`
            + `<div>${BetaDescription.Description}</div>`
            + `<div>`
            + `<ecp-btn id=EnableBetaVersion icon=ews-icon-stars type=permanent>Enable beta</ecp-btn>`
            + `<ecp-btn id=CancelBetaVersion onclick=CreateEnableBetaDialog(true) type=primary>Not right now</ecp-btn>`
            + `</div>`
            + `</div>`
            + `</div>`;

        document.getElementById("EnableBetaBtn").parentNode.innerHTML += html;
        document.getElementById("EnableBetaVersion").addEventListener("click", async () => {
            const myRequest = new ECP.EC_Request("Dashboard_SwitchDashboardVersionType");
            myRequest.AddRequestVariable("DashboardID", DashboardSetting.DashboardID);
            myRequest.AddRequestVariable("ShowBetaDialog", false);
            await myRequest.Submit();
            await EnableBetaVersion(DashboardSetting);
        });

        document.getElementById("CancelBetaVersion").shadowRoot.querySelector("Button").style = "background:var(--neutral-90);color:var(--text-onbg-action);border:0";
        requestAnimationFrame(() => {
            const enableBetaDialog = document.getElementById("EnableBeta");
            enableBetaDialog.style.height = "";
            enableBetaDialog.style.padding = "";
        });
    }
}

async function EnableBetaVersion(DashboardSetting) {
    ECP.Dialog.ShowLoading();
    const myRequest = new ECP.EC_Request("Dashboard_SwitchDashboardVersionType");
    if (EC_Fmt.isMobile) {
        const currentTab = document.querySelector(".TableViewTabContainer .TableViewPageTab.Active");
        if (currentTab?.getAttribute("dashboardid") && currentTab?.getAttribute("dashboardid") !== ECP.CommonDashboards.TableView.toString()) {
            DashboardSetting = {
                DashboardID: EC_Fmt.Null2ZeroInt(currentTab.getAttribute("dashboardid")),
                ExistsBetaVersion: currentTab.getAttribute("existsbetaversion") === "true",
                EnableBeta: currentTab.getAttribute("enablebeta") === "true",
                ShowBetaDialog: currentTab.getAttribute("showbetadialog") === "true",
                BetaType: EC_Fmt.Null2ZeroInt(currentTab.getAttribute("betatype"))
            };
            myRequest.AddRequestVariable("ShowBetaDialog", false);
        }
    }

    myRequest.AddRequestVariable("DashboardID", DashboardSetting.DashboardID);
    myRequest.AddRequestVariable("EnableBeta", !DashboardSetting.EnableBeta);

    const data = await myRequest.Submit();

    if (data.status === "success") {
        window.location.reload();
    }
}

async function CreateBetaTask(Dialog) {
    let FeedbackDetail = Dialog.querySelector("#BetaDetail").value;

    if (FeedbackDetail) {
        // Get Dashboard and UserData
        const UserName = document.querySelector("div [name='UserMenu']").innerText.split("@")[0];
        // EC-10000: Submitting feedback for the Beta is throwing an error when submitting if you select 'Keep Using the Beta' option
        const myDashboardData = new ECP.EC_Request("Get_Dashboard_Information");
        myDashboardData.AddRequestVariable("DashboardID", EC_Fmt.GetPageParameter("DashboardID"));

        const result = await myDashboardData.Submit();

        if (EC_Fmt.isNull(result.ErrorMessage)) {
            FeedbackDetail += `<br><br><b>User:${UserName}<br>EncompassID:${Distributor}`;
            FeedbackDetail = `Beta Dashboard Feedback:<br>${FeedbackDetail}`;
            // Create Task
            let TaskTitle = `Beta Dashboard feedback submitted for the ${result.Rows[0].Dashboard} dashboard`;
            if (!EC_Fmt.isNull(result.Rows[0].Application)) {
                TaskTitle += ` in the ${EC_Fmt.RemoveHTMLFromStr(result.Rows[0].Application)} application`;
            }
            const myRequest = new ECP.EC_Request("BI_CreateTask");
            myRequest.AddRequestVariable("Detail", FeedbackDetail, ECP.EC_Verb.Get);
            myRequest.AddRequestVariable("Task", TaskTitle, ECP.EC_Verb.Get);
            myRequest.AddRequestVariable("AuthenticationID", result.Rows[0].OwnerAuthenticationID, ECP.EC_Verb.Get);
            myRequest.SetReturnType(ECP.EC_ReturnType.Json);
            await myRequest.Submit();
        } else {
            ECP.Dialog.Alert(result.ErrorMessage);
        }
    }
}

function CreateManageBetaDialog(DashboardSetting) {
    const currentTab = document.querySelector(".TableViewTabContainer .TableViewPageTab.Active");
    let DashboardName = document.head.querySelector("title").innerText;
    if (currentTab) {
        DashboardName = currentTab.innerText;
    }
    let htmlB = `Thanks for trying out beta ${DashboardName}! We’re always trying out new things and trying to find new ways to push the envelope.</div>`;
    htmlB += `<div style=padding-top:16px>Your feedback is invaluable in order to continue providing great software experiences. Please feel free to use the box below to tell us about your experience with beta ${DashboardName}.</div>`;
    htmlB += `<textarea id=BetaDetail style=margin-top:13px;width:345px;height:185px></textarea>`;
    const dialog = ECP.Dialog.ShowDialog(
        "Manage beta experience",
        htmlB,
        {
            width: 390,
            height: 490,
            barPosition: "top",
            confirmButtonTitle: "Revert to original",
            cancelButtonTitle: "Keep using the beta",
            cancelButtonAction: async () => {
                await CreateBetaTask(dialog);
                ECP.Dialog.CloseDialog(dialog);
            },
            confirmButtonAction: async () => {
                await CreateBetaTask(dialog);
                await EnableBetaVersion(DashboardSetting);
            }
        }
    );
}

// eslint-disable-next-line no-unused-vars
function refreshMenu() {
    EWS.ClearMenuCache(() => {
        clearDashboardMenuCache();
        window.location.reload(true);
    });
}
